import type { RouteObject } from 'react-router'

import { MyWorkPage } from '@/features/work-items/MyWorkPage'

export const routes: RouteObject[] = [{ path: 'work', element: <MyWorkPage /> }]
